export function assetLinkUrl(assetId: string): string | null {
  if (!assetId) return null;

  return `https://app.${import.meta.env?.VITE_SERVICE_ENVIRONMENT === "-staging" ? "staging." : ""}changeengine.com/content-library?preview=${assetId}`;
}
